import React from 'react';
import { Link } from 'react-router';
import { msg } from "constants/message";
import { ShowIf } from 'components/utils';
import moment from 'moment';
import * as CONFIG from 'constants/config';
import { checkServerLive, LimitFileSize, LimitFileType, LimitFileType2 } from 'constants/config';
import { checkLimitFile } from "constants/checkLimitFile";
import { Reception, QuanLyVanBan } from 'api';
import { Toastr } from 'modules/toastr';
import {
  DropDownChonTinhTrangTaiLieu
} from 'components/tt-forms';
import { DatePicker, Input, DropDown } from "components/tt-forms/common";
import { validatable } from 'components/utils';
import fileDownload from 'js-file-download';
import { downloadFile } from 'components/utils';
import { get } from 'lodash';

class RowItemFileDinhKem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hasChangeDate: false,
      type: this.props.type,
      taiLieuVanThuId: this.props.taiLieuVanThuId,
      taiLieuBaoCaoId: this.props.taiLieuBaoCaoId,
      ten: this.props.ten,
      tenFile: this.props.tenFile,
      tenFileds: this.props.tenFileds,
      ngayQuyetDinh: this.props.ngayQuyetDinh || '',
      soQuyetDinh: this.props.soQuyetDinh,
      progress: 0,
      duongDan: this.props.duongDan,
      isValid: true,
      required: this.props.required,
      typeRequired: this.props.typeRequired,
      newFile: this.props.newFile,

      loaiTepDinhKem: this.props.loaiTepDinhKem,
      loaiQuyTrinh: this.props.loaiQuyTrinh,

      tinhTrang: this.props.tinhTrang,
      taiLieuBangChungId: this.props.taiLieuBangChungId,
      count: this.props.count,

      buocGiaiQuyet: this.props.buocGiaiQuyet,

      phanLoaiQuyTrinh: this.props.phanLoaiQuyTrinh,
      onSave: this.props.onSave,
      isError: false,
      nhomHoSo: get(this.props, 'nhomHoSoInfo.nhomHoSoId'),
      isDsVanBanXuLy: this.props.isDsVanBanXuLy
    }
  }

  componentDidMount() {
    if (this.props.open) {
      this.openUpLoad();
    }
  }

  openUpLoad() {
    this.refs.btnUpload.click();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.type == 'TAI_LIEU_DINH_KEM') {
      const getDate = () => {
        let ngayQuyetDinh = nextProps.ngayQuyetDinh;
        if (!this.state.hasChangeDate) {
          if ((moment(nextProps.ngayQuyetDinh).isValid())) {
            if (!nextProps.unSetNgayBanHanh) {
              ngayQuyetDinh = moment(nextProps.ngayQuyetDinh);
            } else {
              if (moment(nextProps.ngayQuyetDinh).isValid()) {
                ngayQuyetDinh = moment(nextProps.ngayQuyetDinh);
              } else {
                ngayQuyetDinh = new Date(nextProps.ngayQuyetDinh);
              }
            }
          }
        }
        return ngayQuyetDinh;
      }
      this.setState({
        ten: nextProps.ten,
        unSetNgayBanHanh: nextProps.unSetNgayBanHanh,
        tenFile: nextProps.tenFile,
        tenFileds: nextProps.tenFileds,
        soQuyetDinh: nextProps.soQuyetDinh,
        ngayQuyetDinh: getDate(),
        taiLieuVanThuId: nextProps.taiLieuVanThuId,
        taiLieuBaoCaoId: nextProps.taiLieuBaoCaoId,
        progress: 0,
        loaiTepDinhKem: nextProps.loaiTepDinhKem,
        loaiQuyTrinh: nextProps.loaiQuyTrinh,
        duongDan: nextProps.duongDan,
        required: nextProps.required,
        typeRequired: nextProps.typeRequired,
        newFile: nextProps.newFile,
        buocGiaiQuyet: nextProps.buocGiaiQuyet,
        phanLoaiQuyTrinh: nextProps.phanLoaiQuyTrinh,
        onSave: nextProps.onSave,
      });
    } else {
      this.setState({
        ten: nextProps.ten,
        tenFile: nextProps.tenFile,
        tenFileds: nextProps.tenFileds,
        tinhTrang: nextProps.tinhTrang,
        taiLieuVanThuId: nextProps.taiLieuVanThuId,
        taiLieuBaoCaoId: nextProps.taiLieuBaoCaoId,
        duongDan: nextProps.duongDan,
        taiLieuBangChungId: nextProps.taiLieuBangChungId,
        progress: 0,
        required: nextProps.required,
        typeRequired: nextProps.typeRequired,
        newFile: nextProps.newFile,
        buocGiaiQuyet: nextProps.buocGiaiQuyet,
        phanLoaiQuyTrinh: nextProps.phanLoaiQuyTrinh,
        onSave: nextProps.onSave,
      });
    }

    if (nextProps.resetRequired || nextProps.onSave || (this.props.isTiepNhanDon !== undefined && nextProps.isTiepNhanDon != this.props.isTiepNhanDon)) {
      this.setState({
        isValid: true
      })
    }
    if (this.state.typeRequired == 'QDGQ_TTT' || this.state.typeRequired == 'QDGQ_LDT' || this.state.typeRequired == nextProps.loaiVanBanSuggest) {
      if (this.props.ngayQuyetDinhSuggest != nextProps.ngayQuyetDinhSuggest) {
        let newState = {
          ...this.state,
          ngayQuyetDinh: nextProps.ngayQuyetDinhSuggest
        };

        this.setState({ ...newState });
        if (nextProps.ngayQuyetDinhSuggest != this.state.ngayQuyetDinh) {
          this.pushData(newState);
        }
      }
      if (this.props.soVanBanSuggest != nextProps.soVanBanSuggest) {
        let newState = {
          ...this.state,
          soQuyetDinh: nextProps.soVanBanSuggest
        };

        this.setState({ ...newState });

        this.pushData(newState);
      }
    }
  }

  async handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }

    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    await this.setState({
      ...newData,
      hasChangeDate: true
    });
    this.pushData(newData);
  }

  pushData(newState) {
    if (this.state.type == 'TAI_LIEU_DINH_KEM') {
      let params = {
        unSetNgayBanHanh: newState.unSetNgayBanHanh,
        ten: newState.ten,
        tenFile: newState.tenFile,
        tenFileds: newState.tenFileds,
        ngayQuyetDinh: newState.ngayQuyetDinh || '',
        soQuyetDinh: newState.soQuyetDinh,
        taiLieuVanThuId: newState.taiLieuVanThuId,
        taiLieuBaoCaoId: newState.taiLieuBaoCaoId,
        progress: 0,
        loaiTepDinhKem: newState.loaiTepDinhKem,
        loaiQuyTrinh: newState.loaiQuyTrinh,
        duongDan: newState.duongDan,
        required: newState.required,
        typeRequired: newState.typeRequired,
        newFile: newState.newFile,
        buocGiaiQuyet: newState.buocGiaiQuyet,
        phanLoaiQuyTrinh: newState.phanLoaiQuyTrinh,
        isValid: newState.isValid,
        nhomHoSo: newState.nhomHoSo
      }
      this.props.onFileChange(params);
    } else {
      let params = {
        ten: newState.ten,
        tenFile: newState.tenFile,
        tenFileds: newState.tenFileds,
        taiLieuVanThuId: newState.taiLieuVanThuId,
        taiLieuBaoCaoId: newState.taiLieuBaoCaoId,
        tinhTrang: newState.tinhTrang,
        duongDan: newState.duongDan,
        taiLieuBangChungId: newState.taiLieuBangChungId,
        progress: 0,
        required: newState.required,
        typeRequired: newState.typeRequired,
        newFile: newState.newFile,
        buocGiaiQuyet: newState.buocGiaiQuyet,
        phanLoaiQuyTrinh: newState.phanLoaiQuyTrinh,
        isValid: newState.isValid,
        nhomHoSo: newState.nhomHoSo
      }
      this.props.onFileChange(params);
    }
  }

  onChange(name, e) {
    this.state.isValid = true;
    let value = e.target ? e.target.value : e;

    let newState = {
      ...this.state,
      [name]: value
    };

    this.setState({
      ...newState
    });
    this.pushData(newState);
  }

  validate() {
    this.props.handleReset();
    let pass = false;
    if ((this.state.ten == 'Văn bản đính kèm khác' && this.state.duongDan == '') || (this.props.isTiepNhanDon !== undefined && this.props.isTiepNhanDon === false)) {
      pass = true;
    } else if (this.validateSubmitForm()) {
      if (this.state.ngayQuyetDinh && !moment(this.state.ngayQuyetDinh, CONFIG.DateFormat).isValid()) {
        pass = false
      } else if (this.state.onSave) {
        pass = true
      } else if (!this.state.duongDan) {
        this.state.isValid = false;
        this.setState({ ...this.state });
        this.refs.btnUpload.focus();
        pass = false
      } else {
        this.state.isValid = true;
        this.setState({ ...this.state });
        pass = true;
      }
    } else {
      pass = false
    }
    return pass
  }

  validateSubmitForm() {
    let pass = true;
    if (this.props.validators['formDinhKem'] && this.props.validators['formDinhKem'].length) {
      this.props.validators['formDinhKem'].map(validator => {
        if (pass) {
          pass = validator.validate();
        } else if (!this.state.duongDan) {
          this.state.isValid = false;
          this.setState({ ...this.state });
          this.refs.btnUpload.focus();
          validator.validate();
          pass = false
        } else {
          this.state.isValid = false;
          this.setState({ ...this.state });
          validator.validate();
        }
      })
    }
    return pass;
  }

  uploadFile(e) {
    if (e.target.files[0]) {
      this.props.onUpdateUploading && this.props.onUpdateUploading(true);
      let fileName = e.target.files[0].name;
      let ext = fileName.split('.').pop().toLowerCase();
      let fileSize = e.target.files[0].size;
      let fileTypeErrorMsg = this.props.allowExcelFile ? msg.fileTypeErr2 : msg.fileTypeErr;
      if (!checkLimitFile(ext, this.props.allowExcelFile)) {
        Toastr(fileTypeErrorMsg, 'warning');
        this.props.onUpdateUploading(false);
      } else if (fileSize > LimitFileSize * 1024 * 1024) {
        Toastr(msg.fileSizeErr, 'warning');
        this.props.onUpdateUploading(false);
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
        this.props.onUpdateUploading(false);
      } else {
        let params = { field: 'file', file: e.target.files[0] };

        params.progress = (progress) => {
          let progressBar = Math.round((progress.loaded * 100) / progress.total);

          this.setState({ progress: progressBar });
        }

        Reception.actions.postFileUpload.request('', params).then(res => {
          const url = res.data.id;
          let newState = {
            ...this.state,
            progress: 0,
            tenFile: fileName,
            duongDan: url,
            isError: false
          };

          this.setState({ ...newState });

          this.pushData(newState);
          this.props.onUpdateUploading && this.props.onUpdateUploading(false);
        }).catch(error => {
          this.setState({
            progress: 0,
            isError: true
          });
          this.props.onUpdateUploading(false);
        });

      }
    }
  }

  handleRemove() {
    this.props.validators['formDinhKem'] = [];
    this.props.onRemove();
  }

  checkRequire() {
    if (this.state.required &&
      (this.state.typeRequired == 'BB_DOI_THOAI' ||
        ((this.state.ten === 'Dự thảo quyết định về việc giải quyết khiếu nại' || this.state.ten === 'Dự thảo quyết định về việc giải quyết') && this.state.typeRequired == 'DT_KL_GQKN'))) {
      return false
    } else if (this.state.required) {
      return true
    } else {
      return false
    }
  }

  render() {
    return (
      <tr className="tr-middle-content attach-file-rows">
        <td style={{ width: 45, minWidth: 45, maxWidth: 45 }}>{this.props.index + this.state.count + 1}</td>
        <ShowIf condition={this.state.isDsVanBanXuLy}>
          <td style={{ width: 200, minWidth: 200, maxWidth: 200 }} className={this.checkRequire() ? 'required-attach input-attach' : ''}>
            <div>
              <ShowIf condition={this.checkRequire()}>
                <span className='label-required-attach'>*</span>
              </ShowIf>
              <Input className="col-100 no-gutter mb0-18"
                require={this.checkRequire() ? true : false}
                bindValidator={this} channel="formDinhKem"
                placeholder="Tên văn bản" value={this.state.ten} minWidth={50}
                onChange={this.onChange.bind(this, 'ten')}
                name={this.props.name + 'TenTaiLieu' + this.props.index}
                maxLength={255}
              />
            </div>
          </td>
        </ShowIf>
        <ShowIf condition={!this.state.required && !this.state.isDsVanBanXuLy}>
          <td className="input-attach" style={{ width: 200, minWidth: 200, maxWidth: 200 }}>
            <Input className="col-100 no-gutter mb0-18" placeholder={this.state.ten} value={this.state.ten}
              onChange={this.onChange.bind(this, 'ten')} name={this.props.name + 'TenTaiLieu' + this.props.index} maxLength={255}/>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.required && !this.state.isDsVanBanXuLy}>
          <td className='required-attach input-attach' style={{ width: 200, minWidth: 200, maxWidth: 200 }}>
            <span className="val-content pt10">{this.state.ten}<span className='pt-form-helper-text'>&nbsp;*</span></span>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type != 'TAI_LIEU_DINH_KEM'}>
          <td style={{ width: 180, minWidth: 180, maxWidth: 180 }}>
            <DropDownChonTinhTrangTaiLieu className='col-100 mb0-18 no-gutter' name={this.props.name + 'TinhTrang' + this.props.index} selectedValue={this.state.tinhTrang} onChange={this.onChange.bind(this, 'tinhTrang')} />
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type == 'TAI_LIEU_DINH_KEM'}>
          <td style={{ width: 130, minWidth: 130, maxWidth: 130 }} className={this.checkRequire() ? 'required-attach input-attach' : ''}>
            <div>
              <ShowIf condition={this.checkRequire()}>
                <span className='label-required-attach'>*</span>
              </ShowIf>
              <Input className="col-100 no-gutter mb0-18"
                require={this.checkRequire() ? true : false}
                bindValidator={this} channel="formDinhKem"
                placeholder="Số văn bản" value={this.state.soQuyetDinh} minWidth={50}
                onChange={this.onChange.bind(this, 'soQuyetDinh')}
                name={this.props.name + 'SoVanBan' + this.props.index}
                maxLength={255}
              />
            </div>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type == 'TAI_LIEU_DINH_KEM'}>
          <td style={{ width: 201, minWidth: 201, maxWidth: 201 }} className={this.checkRequire() ? 'required-attach input-attach' : ''}>
            <ShowIf condition={this.checkRequire()}>
              <span className='label-required-attach'>*</span>
            </ShowIf>
            <DatePicker className='col-100 no-gutter mb0-18' value={this.state.ngayQuyetDinh}
              onChange={this.handleChangeDate.bind(this, 'ngayQuyetDinh')}
              endDate={new Date()}
              require={this.checkRequire() ? true : false}
              bindValidator={this} channel="formDinhKem"
              name={this.props.name + 'NgayQuyetDinh' + this.props.index}
            />
          </td>
        </ShowIf>
        <td className="none-boder">
          <ShowIf condition={this.state.progress === 0}>
            <ShowIf condition={!checkServerLive}>
              <Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, this.state.duongDan, this.state.tenFile)}>{this.state.tenFile}</Link>
            </ShowIf>
            <ShowIf condition={checkServerLive}>
              <Link className="txt-blue txt-underline" onClick={() => { downloadFile(this.state.duongDan, this.state.tenFile) }}>{this.state.tenFile}</Link>
            </ShowIf>
          </ShowIf>
          <ShowIf condition={!this.state.isValid && !this.state.tenFile && this.state.progress == 0}>
            <div className='pt-form-helper-text mt10'>{msg.uploadRequire}</div>
          </ShowIf>
          <ShowIf condition={this.state.progress == 0 && !this.state.tenFile && this.state.isValid && !this.state.isError}>
            <div className="mt10"><i className="attach-file-description">Bạn chưa tải lên tập tin</i></div>
          </ShowIf>
          <ShowIf condition={this.state.progress == 0 && !this.state.tenFile && this.state.isValid && this.state.isError}>
            <div className="mt10"><i className="attach-file-description error-description">Tập tin tải lên không thành công. Vui lòng thử lại!</i></div>
          </ShowIf>
          <ShowIf condition={this.state.progress > 0}>
            <div className="pt-progress-bar progress-upload pt-intent-primary">
              <div className="pt-progress-meter" style={{ width: `${this.state.progress}%` }} />
            </div>
          </ShowIf>
        </td>
        <td style={{ width: 160, minWidth: 160, maxWidth: 160 }} className={this.checkRequire() ? 'required-attach' : ''}>
          <div>
            <ShowIf condition={this.checkRequire()}>
              <span className='label-required-attach'>*</span>
            </ShowIf>
            <DropDown
              className="col-100"
              options={this.props.listNhomHoSo}
              keyName='giaTri'
              valueName='ten'
              placeholder="Chọn"
              selectedValue={get(this.state, 'nhomHoSo') || get(this.props, 'nhomHoSoInfo.nhomHoSoId')}
              onChange={this.onChange.bind(this, 'nhomHoSo')}
              bindValidator={this}
              channel="formDinhKem"
              require={this.checkRequire() ? true : false}
            />
          </div>
        </td>
        <td style={{ width: 120 }}>
          <div className="wrap-link-todo link-attach">
            <div className="upload_file_content">
              <input type="file" name={this.props.name + 'ButtonUpload' + this.props.index} className={`upload${(this.state.progress || this.props.disabled) ? ' disabled-element' : ''}`} ref='btnUpload' onChange={this.uploadFile.bind(this)} disabled={this.state.progress !== 0 || this.props.disabled} onClick={(event) => { event.target.value = null }} />
              <ShowIf condition={this.state.tenFile.length == 0}>
                <span htmlFor="file">Tải lên tập tin</span>
              </ShowIf>
              <ShowIf condition={this.state.tenFile.length > 0}>
                <span htmlFor="file">Tải lại tập tin</span>
              </ShowIf>
            </div>
            <ShowIf condition={(!this.state.required && !this.props.disabled) || this.state.isDsVanBanXuLy}>
              <Link className="itt-delete" onClick={this.handleRemove.bind(this)}>Xóa</Link>
            </ShowIf>
            <ShowIf condition={!this.state.required && this.props.disabled}>
              <span className="itt-delete disabled-element">Xóa</span>
            </ShowIf>
          </div>
        </td>
      </tr>
    );
  }
}

RowItemFileDinhKem.defaultProps = {
  index: null,
  ngayQuyetDinhSuggest: '',
  soVanBanSuggest: '',
  loaiVanBanSuggest: '',
  validators: {},
  onRemove: function () {
    console.log('Please implement "onRemove()" method')
  },
  type: 'TAI_LIEU_DINH_KEM',
  isValid: true,
  required: false,
  typeRequired: '',
  newFile: false,
  phanLoaiQuyTrinh: '',
  onSave: false,
  name: '',
  disabled: false
}

export default validatable(RowItemFileDinhKem);



// WEBPACK FOOTER //
// ./src/components/upload/rowitem-filedinhkem.jsx